import { HostActionType as e } from "../types/HostActionType.mjs";
import { HostActionIntent as t } from "../types/HostActionIntent.mjs";
import { HostActionFacetKind as n } from "../types/HostActionFacet.mjs";
import { HostActionTargetKind as r } from "../types/HostActionTarget.mjs";
//#region src/mappers/toReviewActions.ts
var i = (i, a) => i.filter((e) => !e.has_host_reply).map((i) => {
	let o = a.get(i.listing_id);
	return {
		id: `${e.ReviewUnanswered}:${i.id}`,
		type: e.ReviewUnanswered,
		intent: t.Decision,
		imageUrl: o?.image ?? void 0,
		avatarName: i.reviewer_name,
		params: {
			guest: i.reviewer_name,
			count: i.overall_rating
		},
		object: o?.listing_title ?? void 0,
		facets: i.body ? [{
			kind: n.Text,
			text: i.body
		}] : void 0,
		createdAt: i.created_at,
		target: { kind: r.Reviews }
	};
});
//#endregion
export { i as toUnansweredReviewActions };
